import {Observable, of, Subject} from "rxjs";
import {Log, LogTag} from "../Log";
import {ILogInfo} from "../../interfaces/ILogInfo";

export class Extension {
  isInstalled = false;
  messageMap = {};
  lastId = 0;


  constructor() {
    this.isInstalled = document.documentElement.getAttribute('player-extension') == 'installed';
  }

  connect(): Observable<any> {
    return of("connected");
  }

  call(command, args=null): Observable<any> {
    return of(null);
  }
}
